var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lg:flex lg:space-x-5",attrs:{"id":"v-body"}},[_c('div',{staticClass:"w-min"},[_c('Navigation'),_c('LeftViews')],1),_c('Table',{staticClass:"w-full"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }